import useTableData from "../../../../state/table/UseTableData";

const useTableRow = (rowId) => {
  const { tableState, onUpdateExpandedIds } = useTableData();

  const onRowClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (rowId) {
      const newExpandedIds = tableState.expandedIds.includes(rowId)
        ? tableState.expandedIds.filter(id => id !== rowId)
        : [...tableState.expandedIds, rowId];

      onUpdateExpandedIds(newExpandedIds);
    }
  };

  return {
    isExpanded: tableState.expandedIds.some(id => id === rowId),
    isSelected: tableState.selectedIds.some(id => id === rowId),
    onRowClicked
  };
};

export default useTableRow;
